import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import Brand from './Brand';
export default function Navigation() {
  const { pathname } = useLocation();
  const { isAuthenticated, user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(false); }, [pathname]);
  const links = [['Accueil', '/'], ['Prestations', '/tarifs'], ['Réalisations', '/galerie'], ['Avis', '/avis']];
  const account = isAuthenticated ? (user?.role === 'admin' ? '/admin' : '/mon-espace') : '/connexion';
  return <header className="korean-header"><a className="korean-skip" href="#main-content">Aller au contenu</a><div className="korean-header-inner">
    <Link to="/" aria-label="Korean Lash Lift by Ali — accueil"><Brand /></Link>
    <button className="korean-mobile-toggle" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="korean-navigation" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'}>{open ? <X /> : <Menu />}</button>
    <nav id="korean-navigation" aria-label="Navigation principale" className={open ? 'is-open' : ''} onKeyDown={event => { if (event.key === 'Escape') setOpen(false); }}>
      {links.map(([label, href]) => <Link key={href} to={href} aria-current={pathname === href ? 'page' : undefined}>{label}</Link>)}
      <Link className="korean-account" to={account}>{isAuthenticated ? 'Mon espace' : 'Connexion'}</Link>
      {isAuthenticated && <button className="korean-logout" onClick={logout}>Déconnexion</button>}
      <Link className="korean-button korean-nav-cta" to={isAuthenticated ? '/mon-espace?tab=booking' : '/connexion'}>Réserver <ArrowUpRight size={16} aria-hidden="true" /></Link>
    </nav></div></header>;
}
